module.exports = __webpack_public_path__ + "static/media/12.fc41c856.jpg";